const BrandMark = ({ dark = false, className = "" }) => (
  <span className={`inline-flex flex-col ${className}`} data-testid="brand-mark">
    <span className="font-logo text-[22px] font-extrabold leading-none tracking-[0.02em]">
      <span className={dark ? "text-ivory" : "text-navy"}>MEDLINK</span>
      <span className="text-gold">X</span>
    </span>
    <span className="mt-1.5 h-[3px] w-9 rounded-full bg-gold" />
  </span>
);

export default BrandMark;
